import { Component, contentChildren, input } from "@angular/core";
import { PageToolbarActionComponent } from "src/app/components/ui/page/page-shared/page-toolbar/items/page-toolbar-action.component";
import { PageToolbarItemType } from "src/app/components/ui/page/page-shared/page-toolbar/page-toolbar-item";
import { PageToolbarItemComponent } from "src/app/components/ui/page/page-shared/page-toolbar/page-toolbar-item.component";

@Component({
  selector: "snt-page-toolbar-action-group",
  template: "",
  providers: [
    {
      provide: PageToolbarItemComponent,
      useExisting: PageToolbarActionGroupComponent
    }
  ],
  standalone: false
})
export class PageToolbarActionGroupComponent {
  type: PageToolbarItemType = "action-group";

  title = input<string | undefined>(undefined);

  actions = contentChildren(PageToolbarActionComponent);
}
